export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/asp_net.51e68bc.svg";